/*
 * Yup validators for attributes associated with a person.
 * Have one parameter to indicate if the field is required or optional.
 */
import * as yup from 'yup'
// TODO Move the messages to this file
import {
  firstNameMessage,
  firstNameLengthMessage,
  middleNameMessage,
  middleNameLengthMessage,
  lastNameMessage,
  lastNameLengthMessage,
  medicareNumberMessage,
  medicaidNumberMessage,
  ssnMessage
} from '../strings/messages'
import { alphaStringYupOptional, alphaStringYupRequired } from './stringYup'
import {
  medicareNumberRegex,
  ssnRegex,
  medicaidNumberRegex
} from '../strings/regex'

// First middle and last names cannot be longer than this
const maxLength = 30
const maxLengthFirstMiddle = 20

export const firstNameYup = (required = true) =>
  required
    ? alphaStringYupRequired(
        firstNameMessage,
        maxLengthFirstMiddle,
        firstNameLengthMessage
      )
    : alphaStringYupOptional(
        firstNameMessage,
        maxLengthFirstMiddle,
        firstNameLengthMessage
      )

export const middleNameYup = (required = false) =>
  required
    ? alphaStringYupRequired(
        middleNameMessage,
        maxLengthFirstMiddle,
        middleNameLengthMessage
      )
    : alphaStringYupOptional(
        middleNameMessage,
        maxLengthFirstMiddle,
        middleNameLengthMessage
      )

export const lastNameYup = (required = true) =>
  required
    ? alphaStringYupRequired(lastNameMessage, maxLength, lastNameLengthMessage)
    : alphaStringYupOptional(lastNameMessage, maxLength, lastNameLengthMessage)

export const medicareYup = (required = false) =>
  required
    ? yup
        .string()
        .matches(medicareNumberRegex, {
          message: medicareNumberMessage,
          excludeEmptyString: false
        })
        .required(medicareNumberMessage)
    : yup.string().matches(medicareNumberRegex, {
        message: medicareNumberMessage,
        excludeEmptyString: true
      })

export const medicaidYup = (required = false) =>
  required
    ? yup
        .string()
        .matches(medicaidNumberRegex, {
          message: medicaidNumberMessage,
          excludeEmptyString: false
        })
        .required(medicaidNumberMessage)
    : yup.string().matches(medicaidNumberRegex, {
        message: medicaidNumberMessage,
        excludeEmptyString: true
      })

export const ssnYup = (required = false) =>
  required
    ? yup
        .string()
        .matches(ssnRegex, {
          message: ssnMessage,
          excludeEmptyString: false
        })
        .required(ssnMessage)
    : yup.string().matches(ssnRegex, {
        message: ssnMessage,
        excludeEmptyString: true
      })
